import { render, staticRenderFns } from "./changePwdDialog.vue?vue&type=template&id=0f4e2a9b&scoped=true"
import script from "./changePwdDialog.vue?vue&type=script&lang=js"
export * from "./changePwdDialog.vue?vue&type=script&lang=js"
import style0 from "./changePwdDialog.vue?vue&type=style&index=0&id=0f4e2a9b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e2a9b",
  null
  
)

export default component.exports